module.exports = __webpack_public_path__ + "static/media/bg-modal.64788c1a.png";